export default "__VITE_ASSET__t8PgCc2O__"